(function () {
  let scriptAppended = false;

  function appendShareaholicScript() {
    if (scriptAppended) { return; }

    const script = document.createElement('script');
    script.src = 'https://cdn.shareaholic.net/assets/pub/shareaholic.js';
    script.async = true;
    script.setAttribute('data-cfasync', 'false');

    document.head.appendChild(script);
    scriptAppended = true;
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(appendShareaholicScript, { timeout: 1500 });
  } else {
    setTimeout(appendShareaholicScript, 0);
  }
})();
